export class LayoutFormatHelper {
    static _a5Format = "A5";
    static _a4Format = "A4";
    static _a3Format = "A3";
    static _a2Format = "A2";
    static _a1Format = "A1";
    static _a0Format = "A0";
    
    static _horizontalOrientation = "Horizontal";
    static _verticalOrientation = "Vertical";

    static _a5Width = 1480;
    static _a5Height = 2100;

    static _a4Width = 2100;
    static _a4Height = 2970;

    static _a3Width = 2970;
    static _a3Height = 4200;

    static _a2Width = 4200;
    static _a2Height = 5940;

    static _a1Width = 5940;
    static _a1Height = 8410;

    static _a0Width = 8410;
    static _a0Height = 11890;

    static createLayoutObject(layoutProps) {
        let id = 0;
        let name = "";
        let format = this._a4Format;
        let orientation = this._verticalOrientation;
        if (null !== layoutProps && undefined !== layoutProps) {
            id = layoutProps.id;
            name = layoutProps.name;
            format = this.getFormatFromDimentions(layoutProps.width, layoutProps.height);
            orientation = this.getOrientationFromDimentions(layoutProps.width, layoutProps.height);
        }

        return {
            id: id,
            modified: false,
            name: name,
            format: format,
            orientation: orientation
        };
    }

    static getFormatFromDimentions(width, height) {
        if ((this._a5Width === width && this._a5Height === height) || (this._a5Width === height && this._a5Height === width)) {
            return this._a5Format;
        }

        if ((this._a4Width === width && this._a4Height === height) || (this._a4Width === height && this._a4Height === width)) {
            return this._a4Format;
        }

        if ((this._a3Width === width && this._a3Height === height) || (this._a3Width === height && this._a3Height === width)) {
            return this._a3Format;
        }

        if ((this._a2Width === width && this._a2Height === height) || (this._a2Width === height && this._a2Height === width)) {
            return this._a2Format;
        }

        if ((this._a1Width === width && this._a1Height === height) || (this._a1Width === height && this._a1Height === width)) {
            return this._a1Format;
        }

        if ((this._a0Width === width && this._a0Height === height) || (this._a0Width === height && this._a0Height === width)) {
            return this._a0Format;
        }

        return "";
    }

    static getOrientationFromDimentions(width, height) {
        return width > height ? this._horizontalOrientation : this._verticalOrientation;
    }

    static getLayoutPropertiesObject(name, format, orientation) {
        let width = 0;
        let height = 0;

        // Set as vertical orientation
        if (this._a5Format === format) {
            width = this._a5Width;
            height = this._a5Height;
        }
        else if (this._a4Format === format) {
            width = this._a4Width;
            height = this._a4Height;
        }
        else if (this._a3Format === format) {
            width = this._a3Width;
            height = this._a3Height;
        }
        else if (this._a2Format === format) {
            width = this._a2Width;
            height = this._a2Height;
        }
        else if (this._a1Format === format) {
            width = this._a1Width;
            height = this._a1Height;
        }
        else if (this._a0Format === format) {
            width = this._a0Width;
            height = this._a0Height;
        }

        if (this._horizontalOrientation === orientation) {
            const temp = width;
            width = height;
            height = temp;
        }

        return {
            name: name,
            width: width,
            height: height
        };
    }
}
